import {createSlice, isAnyOf} from '@reduxjs/toolkit'
import { ORDER_ITEM } from 'src/app/_interfaces/order.interface'
import { getPriceLogsAsync } from '../actions/priceLogsActions'

type InitialState = {
    priceLogsLoading:boolean
    priceLogs:ORDER_ITEM[]|[]
    priceLogsPaginationData:{
        // next:string|null
        // previous:string|null
        pageNumber:number
        count:number
    }
}
const initialState:InitialState  = {
  priceLogsLoading:false,
  priceLogs:[],
  priceLogsPaginationData:{
    count:0,
    pageNumber:0
  },
}

const priceLogsSlice = createSlice({
  name: 'priceLogsSlice',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getPriceLogsAsync.pending), (state) => {
      console.log('getPriceLogsAsync is in pending state ')
      state.priceLogsLoading = true
    })
    builder.addMatcher(isAnyOf(getPriceLogsAsync.rejected), (state) => {
      console.log('getPriceLogsAsync is in rejected state ')
      state.priceLogsLoading = false
    })
    builder.addMatcher(isAnyOf(getPriceLogsAsync.fulfilled), (state, action) => {
        console.log('getPriceLogsAsync is in fulfilled state ', action.payload )
        state.priceLogsLoading = false
        state.priceLogs = action.payload.data.product_changes
        state.priceLogsPaginationData.count = action.payload?.data.total_items
        state.priceLogsPaginationData.pageNumber = action.payload?.data.current_page


    })
  },
  reducers: { 
    
  },
})

export const {} = priceLogsSlice.actions

export default priceLogsSlice.reducer
